// eslint-disable-next-line import/prefer-default-export
export const ScientificWorkTypes = {
  THESIS: 100,
  ARTICLE: 200,
  OTHER: 300,
  INDIVIDUAL_WORK_PLAN: 400,
  THEORETICAL_METHODOLOGICAL_PROGRAM: 500,
  DISSERTATION_TOPIC_ANALYTICAL_INFO: 600,
  SEMINAR_REPORT: 700,
  FOREIGN_ARTICLE: 800,
  REPORT: 900,
  DISSERTATION: 1000,
  DISSERTATION_AUTO_REFER: 1100,
  MONOGRAPH: 1200,
}
export const ScientificWorkTypeList = [
  {
    id: ScientificWorkTypes.ARTICLE, uz: 'Maqola', ru: 'Статья', en: 'Article',
  },
  {
    id: ScientificWorkTypes.THESIS, uz: 'Tezis', ru: 'Тезис', en: 'Thesis',
  },
  {
    id: ScientificWorkTypes.INDIVIDUAL_WORK_PLAN, uz: 'Yakka tartibdagi reja', ru: 'Индивидуальный план работы', en: 'Individual Work Plan',
  },
  {
    id: ScientificWorkTypes.THEORETICAL_METHODOLOGICAL_PROGRAM, uz: 'Nazariy metodologik dastur', ru: 'Теоретическая методологическая программа', en: 'Theoretical Methodological Program',
  },
  {
    id: ScientificWorkTypes.DISSERTATION_TOPIC_ANALYTICAL_INFO, uz: 'Dissertatsiya mavzusi bo‘yicha tahliliy ma’lumot', ru: 'Аналитическая информация по теме диссертации', en: 'Dissertation Topic Analytical Info',
  },
  {
    id: ScientificWorkTypes.SEMINAR_REPORT, uz: 'Seminar bayonnomasi', ru: 'Доклад на семинаре', en: 'Seminar Report',
  },
  {
    id: ScientificWorkTypes.FOREIGN_ARTICLE, uz: 'Xorijiy maqola', ru: 'Иностранная статья', en: 'Foreign Article',
  },
  {
    id: ScientificWorkTypes.REPORT, uz: 'Hisobot', ru: 'Отчет', en: 'Report',
  },
  {
    id: ScientificWorkTypes.DISSERTATION, uz: 'Dissertatsiya', ru: 'Диссертация', en: 'Dissertation',
  },
  {
    id: ScientificWorkTypes.DISSERTATION_AUTO_REFER, uz: 'Dissertatsiyaning avtoreferati', ru: 'Автореферат диссертации', en: 'Dissertation Auto-Refer',
  },
  {
    id: ScientificWorkTypes.MONOGRAPH, uz: 'Monografiya” (ijtimoiy-gumanitar fanlar bo‘yicha)', ru: 'Монография', en: 'Monograph',
  },
]
